import React from "react";
import { Link } from "react-router-dom";
import "./LegalPages.css";
import AnimatedPage from "../../components/AnimatedPage/AnimatedPage";
import { translations } from "../../utils/translations";

const TermsOfService = () => {
  // idioma
  const currentLang = localStorage.getItem("language") || "es";
  const t =
    translations[currentLang]?.termsOfService ||
    translations["es"].termsOfService;

  return (
    <AnimatedPage>
      <div className="legal-container">
        <Link to="/" className="legal-back-btn">
          {t.backBtn}
        </Link>
        <h1>{t.mainTitle}</h1>
        <p>{t.lastUpdate}</p>

        <section>
          <h2>{t.sec1Title}</h2>
          <p>{t.sec1Text}</p>
        </section>

        <section>
          <h2>{t.sec2Title}</h2>
          <p>{t.sec2Text}</p>
        </section>

        <section>
          <h2>{t.sec3Title}</h2>
          <p>{t.sec3Text}</p>
        </section>

        <section>
          <h2>{t.sec4Title}</h2>
          <p>{t.sec4Text}</p>
        </section>

        <section>
          <h2>{t.sec5Title}</h2>
          <p>{t.sec5Text}</p>
        </section>

        <section>
          <h2>{t.sec6Title}</h2>
          <p>{t.sec6Text}</p>
        </section>
      </div>
    </AnimatedPage>
  );
};

export default TermsOfService;
